import { ImagePreloadDirective } from './imagePreload.directive';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    // ImagePreloadDirective
  ],
  imports: [],
  exports: [
    // ImagePreloadDirective
  ]
})
export class DirectivesModule { }
